module.exports = __webpack_public_path__ + "img/blank_compare_periods.59885e12.png";